//Global keys
let locales = {
    "sidebar_companiesMenu": "Campagna Email",
    "sidebar_Companies": "Affiliati 🤝",
    "sidebar_lista1": "Servizi Marketing",
    "sidebar_list2": "Partner Affiliati",
    "sidebar_Agenti": "Agenti",
    "sidebar_areaManager": "Area Manager",
    "sidebar_emailSentList": "Email Inviate (controllo)",
    "sidebar_parametri": "Archivio Email (controllo)",
    "sidebar_listParametri": "Impostazioni",
    "sidebar_workFlowManagement": "Processo affiliazione",
    "sidebar_emailProgramming": "Registro Promemoria ✉",
    "sidebar_documentsAndContracts": "Documenti e Contratti",
    "sidebar_documentsUpdated": "Files Aggiornati",
    "sidebar_usersManagement": "Gestione degli utenti",
    "sidebar_roles": "Ruoli",
    "sidebar_permissions": "Permessi",
    "sidebar_users": "Utenti",
    "sidebar_emailCampaign": "Campagna Email",
    "sidebar_ReportCSVMenu": "Estrazione lead (CSV)",
    "sidebar_teamLeads": "Area lavoro Lead (Team)",
};

export default locales;
